export var Interface;
(function (Interface) {
    Interface["Site"] = "site";
    Interface["Page"] = "page";
    Interface["Zone"] = "zone";
})(Interface || (Interface = {}));
export const InterfaceKey = {
    [Interface.Site]: 'INTERFACE.SITE',
    [Interface.Page]: 'INTERFACE.PAGE_GROUP',
    [Interface.Zone]: 'INTERFACE.ZONE',
};
//# sourceMappingURL=interface.js.map